import {useQuery} from '@github-ui/react-query'

interface EnterpriseNewTasksData {
  /**
   * Whether to render the experiment at all
   *
   * `false`: the page will render completely normally
   * `true`: we will track the impression and render the experience
   */
  enableEnterpriseNewTasksExperiment: boolean

  /**
   * `false`: track the A/B impression but don't show anything different
   * `true`: track the A/B impression and show the New Tasks button
   */
  showNewTasksButton: boolean
}

const ENTERPRISE_TASKS_ENDPOINT = '/in-product-messaging/enterprise-new-tasks-indicator.json'

export function useEnterpriseTasksData() {
  return useQuery({
    queryKey: ['enterprise-tasks-data', ENTERPRISE_TASKS_ENDPOINT],
    queryFn: async () => {
      const response = await fetch(ENTERPRISE_TASKS_ENDPOINT, {credentials: 'include'})
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`)
      }
      return response.json() as Promise<EnterpriseNewTasksData>
    },
  })
}
